// extracted by mini-css-extract-plugin
export default {"BottomSheetBody":"BottomSheetBody_BottomSheetBody__65WTk"};